import { ToastType } from 'react-toastify';

import { getObjectSelectedClient } from '@domain/object-selected';
import { showToast } from '../../../shared/components/messages-and-errors/ToastsNotifications';
import { createMiddleware } from '../../../shared/redux';

import {
    LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_SUCCESS,
    LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_ERROR,
    LOJA_INTEGRADA_GET_DATA_REQUEST_ERROR,
} from './loja-integrada.state';

import { API_FAIL_DEFAULT_OP_MESSAGE, API_SUCCESS_OP_MESSAGE } from './loja-integrada.constants';
import { getActiveIntegrationsAction } from '../integrations-list/integrations-list.state';
import { getErrorKey } from '../../../shared/utils/errors';

const defaultToastProps = {
    autoClose: 2000, toastId: 'loja-integrada-toast', height: 300,
};

export const lojaIntegradaMiddleware = createMiddleware({
    [LOJA_INTEGRADA_GET_DATA_REQUEST_ERROR]: (_, action) => {
        const message = getErrorKey(action.payload.response, API_FAIL_DEFAULT_OP_MESSAGE);

        showToast(message, ToastType.ERROR, {
            ...defaultToastProps,
            toastId: 'loja-integrada-get-data-error',
        });
    },
    [LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_ERROR]: (_, action) => {
        const message = getErrorKey(action.payload.response, API_FAIL_DEFAULT_OP_MESSAGE);

        showToast(message, ToastType.ERROR, {
            ...defaultToastProps,
            toastId: 'loja-integrada-save-error',
        });
    },
    [LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_SUCCESS]: (state) => {
        const { id } = getObjectSelectedClient(state);

        showToast(API_SUCCESS_OP_MESSAGE, ToastType.SUCCESS, defaultToastProps);

        return getActiveIntegrationsAction(id);
    },
});
